import { motion } from "framer-motion";
import { LoadingState } from "@/components/LoadingStates";

export function LoadingScreen({ konamiMode = false }: { konamiMode?: boolean }) {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      className={`fixed inset-0 z-50 flex items-center justify-center font-mono backdrop-blur-sm transition-colors duration-300 ${konamiMode ? "bg-[#0A0A0A]/80 text-[#00FFFF]" : "bg-black/80 text-green-400"}`}
    >
      <LoadingState
        variant={konamiMode ? "konami" : "terminal"}
        message={konamiMode ? "loading ~/secret/dev/dimension..." : "loading ~/workspace..."}
        size="lg"
      />
    </motion.div>
  );
}
